// src/components/ThemeToggle.js
import React from "react";
import { FaSun, FaMoon, FaAdjust } from "react-icons/fa";
import { useTheme } from "../context/ThemeContext";
import "./ThemeToggle.css";

const ORDER = ["system", "light", "dark"];
const META = {
  system: { icon: FaAdjust, label: "System" },
  light:  { icon: FaSun,    label: "Light"  },
  dark:   { icon: FaMoon,   label: "Dark"   },
};

const ThemeToggle = ({ className = "" }) => {
  const theme = useTheme();
  if (!theme) return null;
  const { pref, cycle } = theme;
  const { icon: Icon, label } = META[pref];
  const next = META[ORDER[(ORDER.indexOf(pref) + 1) % ORDER.length]].label;

  return (
    <button
      type="button"
      className={`theme-toggle ${className}`.trim()}
      onClick={cycle}
      title={`Theme: ${label} (click for ${next})`}
      aria-label={`Theme: ${label}. Click to switch to ${next}.`}
    >
      <Icon size={14} />
    </button>
  );
};

export default ThemeToggle;
